<script lang="ts">
  import { onMount } from "svelte";
  import Router, { type ConditionsFailedEvent } from 'svelte-spa-router';
  import "./app.css";
  import { msalAuthenticator } from "./infrastructure/accounts/auth";
  import routes from "./presentation/routes/routes";
  import {authInitialized} from "./infrastructure/accounts/authStore"
  import { errorStore } from "./infrastructure/defaults/errorStore";
  import AuthGuard from "./presentation/accounts/AuthGuard.svelte";
  import {t, isLoading } from 'svelte-i18n'
  import './i18n'
  import { ModeWatcher } from "mode-watcher";
  import AuthProvider from "./presentation/contexts/AuthProvider.svelte";
  import TemplateProvider from "./presentation/templates/template-provider.svelte";
  import { QueryClient, QueryClientProvider } from '@sveltestack/svelte-query'
  import TestTable from "./presentation/projects/edit/components/test-table.svelte";
  import HubProvider from "./presentation/main/realtime/HubProvider.svelte";
  import { Toaster } from "svelte-sonner";
  import {appQueryClient} from '$src/application/main/queryClient'

  onMount(async() => {
    
    await msalAuthenticator.initialize();

    errorStore.subscribe(value => {
      if(value) {
        window.location.hash = '#/error';
      }
    })

  });

</script>

<main>
  {#if $isLoading}
    <div>loading locale...</div>
  {:else}
   <ModeWatcher />

    {#if $authInitialized}
      <QueryClientProvider client={appQueryClient}>
        <AuthGuard>
          <AuthProvider>
            <HubProvider>
              <Router {routes} />
              <Toaster />
            </HubProvider>
          </AuthProvider>
        </AuthGuard>
      </QueryClientProvider>
    {/if}
  
  {/if}
 
 

</main>

<style>

</style>